// extracted by mini-css-extract-plugin
export default {"block_left_02":"index_block_left_02_Dbb8w","imgCon01":"index_imgCon01_vGCds","text":"index_text_rFG98","textbg":"index_textbg_1h8d-","imgCon02":"index_imgCon02_wLzeo"};